import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { InvestmentWorkflowType } from '@dealstack/shared/lib/generated';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export const formatApplicabilityLabel = (
	value: InvestmentWorkflowType,
	tMipManage: TranslateFunction<I18Namespaces.MIP_MANAGE>
): string => {
	const labelMap: Record<InvestmentWorkflowType, string> = {
		[InvestmentWorkflowType.JOINER_CREATE]: tMipManage('master_documents.text.joiner_create'),
		[InvestmentWorkflowType.JOINER]: tMipManage('master_documents.text.joiner'),
		[InvestmentWorkflowType.ALLOCATION]: tMipManage('master_documents.text.allocation'),
		[InvestmentWorkflowType.LEAVER]: tMipManage('master_documents.text.leaver'),
	};
	return labelMap[value] || value;
};
